import { IComboBoxStyles } from "office-ui-fabric-react/lib/ComboBox";
import { IButtonStyles } from "office-ui-fabric-react/lib/Button";
import { FontSizes } from "@uifabric/fluent-theme";

export const optionsS: Partial<IComboBoxStyles> = {
  optionsContainer: {
    maxHeight: 500,
  },

  label: {
    fontSize: FontSizes.size16,
  },
};

export const closeBtnS: Partial<IButtonStyles> = {
  root: {
    display: "none",
  },
};
